import { DirectoryRefreshEndpoint } from '@core/types/types.endpoint.directory';
import { useDirectoryUpdater } from '@frontend/shared/hooks/shared.hook.useDirectoryUpdater';
import { useInterval } from '@frontend/shared/hooks/shared.hook.useInterval';
import { useSubmitter } from '@frontend/shared/hooks/useSubmitter';
import { callApi } from '@frontend/shared/util/util.callApi';

export function useDirectoryRefresher(
  options: DirectoryRefreshEndpoint['body'],
  condition: boolean,
  interval = 5000,
) {
  const updater = useDirectoryUpdater();

  const refresh = useSubmitter(async () => {
    const [, res] = await callApi<DirectoryRefreshEndpoint>(
      '/directory/refresh',
      options,
    );

    updater(res);
  });

  // Refresh every 5 seconds if syncing
  useInterval(() => {
    if (condition) {
      refresh.submit();
    }
  }, interval);

  return refresh;
}
